//Libs
import * as _ from 'lodash';
//Constants
import * as ACTIONS from './actionTypes';
//Types
import {  LMoperationHours, OperationHour } from './types';
import { ActionGetLMOperationHoursAPISuccess, ActionPostLMOperationHoursAPISuccess } from './actions';
//Types

export interface EngineOperationHourState {
  operationHoursType: string
  operationHours?: OperationHour[]
}

const defaultState: EngineOperationHourState = {
  operationHoursType:"",
  operationHours: undefined
};

type GetLMOperationHoursAction = ActionGetLMOperationHoursAPISuccess | ActionPostLMOperationHoursAPISuccess;

function operationHoursReducer(state: EngineOperationHourState = defaultState, action: GetLMOperationHoursAction): EngineOperationHourState {
  switch (action.type) {
    case ACTIONS.GET_LMOPERATIONHOURS_API_SUCCESS:
      {
        const {
          operationHoursType,
          operationHours
        } = (action as ActionGetLMOperationHoursAPISuccess).lmoperationHours
        return {
          ...state,
          operationHoursType: operationHoursType, 
          operationHours: operationHours
        }
      }
    case ACTIONS.POST_LMOPERATIONHOURS_API_SUCCESS:
      {
        const { operationHoursType, operationHours } = (action as ActionPostLMOperationHoursAPISuccess).lmoperationHours
        return {
          ...state,
          operationHoursType: operationHoursType,
          operationHours: operationHours
         // operationHours: operationHours ? { ...operationHours } : undefined
        }
      }
    default: {
      return {
        ...state
      }
    }
  }

}


export default operationHoursReducer